import gql from 'graphql-tag';
export const DEVICE_QUERY = gql`
  query getDevice($serial: String!) {
    device(serial: $serial) {
      serial
      created_ts
      active {
        snn
        meta
        profile
        providerReference {
          snn
          name
          tags
          created_ts
        }
        serviceStub {
          snn
          ref
          name
          type
          location {
            latitude
            longitude
            point
            streetAddress
            locality
            municipality
            province
            state
            country
          }
          friends
        }
        contractStub {
          snn
          ref
          name
          type
          provider
          location {
            latitude
            longitude
            point
            streetAddress
            locality
            municipality
            province
            state
            country
          }
          policyNumber
          riskCode
          partyCode
          customer
          phoneNumber
          emailAddress
          customerStub {
            snn
            firstName
            lastName
          }
        }
        location {
          latitude
          longitude
        }
        shadowReference {
          snn
          serial
          state {
            reported
          }
          metadata {
            reported
          }
        }
        contractReference {
          snn
          ref
          version
          created_ts
          started_ts
          finished_ts
          closed_ts
          state
          type
          provider
          lastCompany
          name
          policyNumber
          riskCode
          partyCode
          services {
            snn
            ref
            type
            name
            created_ts
            started_ts
            finished_ts
            state
          }
          billables {
            timestamp
            identifier
            sku
            service
            type
            description
            task
            installerCompany
            user
          }
          devicesCollection {
            items: esItems {
              serial
              profile
              created_ts
              meta
              active {
                snn
                service
                providerReference {
                  snn
                  name
                  tags
                  created_ts
                }
                location {
                  latitude
                  longitude
                }
                shadowReference {
                  snn
                  serial
                  state {
                    reported
                  }
                  metadata {
                    reported
                  }
                }
              }
            }
          }
          location {
            latitude
            longitude
            point
            streetAddress
            locality
            municipality
            province
            state
            country
          }
          providerReference {
            snn
            name
            tags
            created_ts
          }
        }
        service
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/providers/devices/queries.ts